import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide9 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={8}
      total={total}
      label="Accounting Close"
      kicker={t.kicker}
      onActive={onActive}
      bgStyle={{
        "--slide-bg": "radial-gradient(700px 560px at 76% 36%,rgba(216,182,46,.2),transparent 66%),linear-gradient(110deg,#020202,#07110d,#020202)"
      }}
    >

      <div className="split">
        <div>
          
          <h2>{t.title}</h2>
          <p className="lead">{t.body}</p>
          
          <div className="pillrow">
            <span className="pill">Diário</span>
            <span className="pill">Razão</span>
            <span className="pill">Balancete</span>
            <span className="pill">Balanço Patrimonial</span>
            <span className="pill">DRE</span>
            <span className="pill">Locked periods</span>
          </div>
        </div>
        
        <div className="grid two">
          <div className="card">
            <span className="num">01</span>
            <h3>{t.c1Title}</h3>
            <p>{t.c1Body}</p>
          </div>
          <div className="card">
            <span className="num">02</span>
            <h3>{t.c2Title}</h3>
            <p>{t.c2Body}</p>
          </div>
          <div className="card">
            <span className="num">03</span>
            <h3>{t.c3Title}</h3>
            <p>{t.c3Body}</p>
          </div>
          <div className="card">
            <span className="num">04</span>
            <h3>{t.c4Title}</h3>
            <p>{t.c4Body}</p>
          </div>
        </div>
      </div>
    </SlideShell>
  );
};





